import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Contract } from 'services/action';

import { Page, Button } from 'ui/components';
import _ from 'underscore';
import { formatDate } from 'utilities/common';
import { ShipmentList, Shipments } from '../list/component/form';
import { General, Manifest } from './component/form';
import { UTCFormat } from 'utilities/common';

const initialState = {
  form_general: null,
  shipment_lists: [],
  update: null,
  data: null,
  manifest: null,
  shipmentClone: null,
};

const UpdateScreen = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateForm = useSelector((state) => state?.Form);

  const [
    { form_general, shipment_lists, update, data, shipmentClone, manifest },
    setState,
  ] = React.useState(initialState);

  const $onLoad = async (id) => {
    const req = await Dispatch(Contract.$show(id));

    if (req?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: req?.data }));
    }
  };

  const $handleDelete = async (id) => {
    let newList = [...shipment_lists];
    newList.splice(id, 1);
    setState((prevState) => ({ ...prevState, shipment_lists: newList }));
  };

  const $handleUpdate = async (d, id) => {
    setState((prevState) => ({
      ...prevState,
      update: { id: id, data: shipment_lists[id] },
    }));
  };

  const $onUpdate = async (d) => {
    let newList = [...shipment_lists];
    newList[update?.id] = d;

    setState((prevState) => ({
      ...prevState,
      shipment_lists: newList,
      update: null,
    }));
  };

  const $onAddPoint = async (type) => {
    let x = Object.assign({}, _.last(shipment_lists));

    x.items = [{}];

    if (type === 'pickup') {
      x.type = 'pickup';
      x.origin = null;
      x.etd_time = '';
    } else if (type === 'reverse') {
      const o = x.origin;
      const d = x.destination;
      x.type = 'reverse';
      x.origin = d;
      x.destination = o;
      x.etd_time = '';
    } else {
      x.type = 'drop_point';
      x.destination = null;
      x.eta_time = '';
    }

    setState((prevState) => ({
      ...prevState,
      shipmentClone: x,
    }));
  };

  const $handleSubmit = async () => {
    let newList = [];

    await shipment_lists.forEach((data) => {
      newList.push({
        origin_id: data?.origin?.id,
        destination_id: data?.destination?.id,
        etd_time: UTCFormat('', data?.etd_time, true),
        eta_time: UTCFormat('', data?.eta_time, true),
        items: data?.items,
        type: data?.type,
      });
    });

    const payload = {
      repeat_type: form_general?.repeat_type,
      repeat_day: form_general?.repeat_day,
      service_type_id: form_general?.serviceType?.id,
      customer_id: form_general?.customer?.id,
      price: form_general?.price,
      start_at: form_general?.start_at?.formatted,
      end_at: form_general?.end_at?.formatted,
      auto_manifest: form_general?.auto_manifest,
      shipments: newList,
      shipper: form_general?.shipper,
    };

    if (form_general?.auto_manifest && manifest) {
      payload.manifest = {
        moda_type: manifest?.moda_type?.value,
        shipping_method: manifest?.shipping_method?.value,
        vendor_id: manifest?.vendor?.id,
        vehicle_type_id: manifest?.vehicleType?.id,
        vendor_service_type_id: manifest?.serviceType?.id,
      };
    }

    const req = await Dispatch(Contract.$update(data?.id, payload));

    if (req?.message === 'success') {
      History.push(`/order/contract/${req?.data?.id}`);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, []);

  React.useEffect(() => {
    if (!data) return;

    let d = [];
    _.each(data?.shipments, function (i) {
      d.push({
        ...i,
        etd_time: formatDate(i?.shipment?.etd_at, 'HH:mm'),
        eta_time: formatDate(i?.shipment?.eta_at, 'HH:mm'),
        type: i?.type,
      });
    });

    setState((prevState) => ({ ...prevState, shipment_lists: d }));
  }, [data]);

  return (
    <Page type="form" onSubmit={$handleSubmit} className="detail-fixed">
      <Page.Header
        title="Perbaharui"
        className="bg-light"
        backTo="/order/contract"
      />

      <Page.Body className="row bg-light border-top">
        <div
          className="col-12 col-md-4 position-md-fixed bg-white h-100 ps-3 border-end border-sm-none"
          style={{ paddingRight: 10 }}
        >
          <General
            data={data}
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, form_general: e }))
            }
          />
        </div>
        <div className="col-md-8 col-12 offset-md-4 pe-0 ps-0 ps-md-0 mt-5 mt-md-0">
          {form_general?.auto_manifest && (
            <Manifest
              data={data}
              form_general={form_general}
              onChange={(e) =>
                setState((prevState) => ({ ...prevState, manifest: e }))
              }
            />
          )}

          <Shipments
            isContract
            service={form_general?.service}
            serviceType={form_general?.service_type}
            data={update?.data}
            lastData={shipmentClone}
            customer={form_general?.customer}
            onSave={(e) =>
              setState((prevState) => ({
                ...prevState,
                shipment_lists: [...prevState?.shipment_lists, e],
              }))
            }
            onUpdate={$onUpdate}
            onAddPoint={$onAddPoint}
            firstData={update?.firstData}
            isEmptyList={shipment_lists?.length === 0 ? true : false}
          />
          {StateForm?.errors?.shipments && (
            <div className="p-3 pt-0">
              <div className="alert alert-danger">
                {StateForm?.errors?.shipments}
              </div>
            </div>
          )}
          <ShipmentList
            data={shipment_lists}
            service={form_general?.service}
            onDelete={$handleDelete}
            onUpdate={$handleUpdate}
            setTotal={(e) =>
              setState((prevState) => ({
                ...prevState,
                total: e,
              }))
            }
          />
        </div>
      </Page.Body>
      <Page.Footer className="bg-light justify-content-center gap-md-2 pt-2 pb-3 mb-2 mb-md-0 border-top d-md-flex d-block flex-wrap">
        <Button
          type="button"
          className="btn-secondary py-md-2"
          onClick={() => {
            History.replace(`/order/contract`);
          }}
        >
          Batal &amp; Kembali
        </Button>
        <Button
          type="submit"
          loading={StateForm?.loading}
          className="btn-primary py-md-2"
        >
          Simpan
        </Button>
      </Page.Footer>
    </Page>
  );
};

export default UpdateScreen;
